"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var log2 = Math.log2 ? Math.log2 : function (x) {
  return Math.log(x) / Math.LN2;
};

exports.default = log2;


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/~/google-map-react/lib/utils/math/log2.js
// module id = 2107
// module chunks = 0